import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
import { images } from '../data/site';
const SHOW_MS = 5000;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(i => (i + 1) % recentBuyers.length);
      setMinutesAgo(1 + Math.floor(Math.random() * 14));
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), SHOW_MS);
    };
    let loop: number;
    const first = window.setTimeout(() => {
      show();
      loop = window.setInterval(show, SHOW_MS + GAP_MS);
    }, 6000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed left-3 right-3 top-3 z-50 flex justify-center sm:bottom-24 sm:left-5 sm:right-auto sm:top-auto" aria-live="polite" data-id="element-41" data-mp="1151wdwl8snld">
      <AnimatePresence data-id="element-42" data-mp="1ay0pnrrop2bb">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl border border-navy-900/10 bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(10,27,56,0.45)]" data-id="element-43" data-mp="n6lf5bpr7eoz">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-navy-950 object-contain p-1" data-id="element-44" data-mp="23lmzvivf3575" />
            <div className="min-w-0" data-id="element-45" data-mp="2apcpataouper">
              <p className="text-sm leading-snug text-ink" data-id="element-46" data-mp="2aobgkvh5af07">
                <strong className="font-bold" data-id="element-47" data-mp="2fmv1qtnwzmri">{buyer.name}</strong> from {buyer.country} <span aria-hidden="true" data-id="element-48" data-mp="2kmr4kpkvl85h">{buyer.flag}</span>
              </p>
              <p className="text-sm font-semibold text-navy-900" data-id="element-49" data-mp="2kko57exu22o3">just purchased Smile Design Roadmap™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-go-dark" data-id="element-50" data-mp="2pjhndko2ehul">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-51" data-mp="1rzwo03r6isxa" /> Verified · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink/40 hover:text-ink/70" aria-label="Dismiss notification" data-id="element-52" data-mp="21vpzdjt5wgdh">
              <XIcon className="h-4 w-4" data-id="element-53" data-mp="195hp0e4vb09g" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}